import React from 'react';
import Location from './Location';
import { locations } from '../../../data/locations';

export default function LocationsPage() {
	return (
		<div className='locationspage'>
			<div className='locations-banner'>
				<img src='assets/giordanos_logo-red.svg' alt='' />
			</div>
			<div className='locations-container'>
				{locations.map((location) => (
					<Location
						key={location.storeId}
						name={location.name}
						address={location.address}
						phone={location.phone}
					/>
				))}
			</div>
			<div className='image-container'>
				<img src='assets/bgi__chicago-stamps.png' alt='' />
			</div>
		</div>
	);
}
